// Added by Sejune Oh on 2020-02-28
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react'
import { createStyles, Theme, makeStyles, useTheme } from '@material-ui/core'
import classNames from 'classnames'

// UI
import {
  Checkbox as MaterilUICheckbox,
  CheckboxProps as MaterialUICheckboxProps,
  FormControlLabel as MaterilUIFormControlLabel,
} from '@/components/_primes/v2'
import { KeyIndexedObject } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
export interface CheckboxProps extends MaterialUICheckboxProps {
  /** Checkbox 옆 라벨 */
  label?: string
  /** Checkbox CSS Style (inline) */
  labelStyle?: React.CSSProperties
  /** Checkbox CSS Style (class) */
  labelClassName?: string
  /** Checkbox의 checked가 변경될 때 이벤트 핸들러  */
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void
  /** Default checked */
  checked?: boolean
  /** Custom checkobx input props */
  customInputProps?: KeyIndexedObject<string>
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * Material UI의 Checkbox 입니다.<br/>
 * - API 문서 : https://material-ui.com/api/checkbox/#checkbox-api
 *
 */
const Checkbox: FC<CheckboxProps> = ({
  label,
  labelStyle,
  labelClassName,
  onChange,
  checked,
  inputProps,
  customInputProps,
  ...props
}) => {
  const theme = useTheme()
  const classes = useStyles(theme)

  // Single checkbox
  if (!label)
    return ( 
      <MaterilUICheckbox
        {...props}
        style={labelStyle}
        color="primary"
        onChange={onChange}
        checked={checked}
        inputProps={{ ...inputProps, ...customInputProps }}
      />
    )

  // With label
  return (
    <MaterilUIFormControlLabel
      style={labelStyle}
      className={classNames(classes.labelBase, labelClassName)}
      control={
        <MaterilUICheckbox
          {...props}
          color="primary"
          onChange={onChange}
          checked={checked}
          inputProps={{ ...inputProps, ...customInputProps }}
        ></MaterilUICheckbox>
      }
      label={label}
    ></MaterilUIFormControlLabel>
  )
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    labelBase: {
      color: '#fff',
    },
  })
)

export default Checkbox
